module.exports = __webpack_public_path__ + "img/7.525ad565.jpg";